// extracted by mini-css-extract-plugin
module.exports = {"container":"vLnDbsujYbNNJlYI9miPg","sidebarSmall":"IwCAFrNNaNjeZrjGfodBL","shadow":"HsA__gfnG_b4e4IvWlfyq","flex":"OsaTaYVXKXVD_IMxK60Im","sections":"IsKvx5s1l9-FwOK0qSjoq"};